import { Component, EventEmitter } from '@angular/core';
import moment from 'moment';
import { MaterialDateRangeComponent, DateRange} from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-vessel-report-toolbar',
  templateUrl: './noon-reports-v202005.header.component.html',
  imports: [SharedModule, MaterialDateRangeComponent, MatButtonModule],
  standalone:true
})
export class NoonReportsToolbarComponent  {
  date: EventEmitter<DateRange> = new EventEmitter<DateRange>();
  downloadExcelReport: EventEmitter<void> = new EventEmitter<void>();
  dateRange: DateRange = {
    startDate: moment(new Date()).subtract(100, 'days').toDate(),
    endDate: new Date()
  };

  selectDateRange(dateRange: DateRange) {
    if (dateRange) {
      this.date.emit(dateRange);
    }
  }

  downloadReports() {
    this.downloadExcelReport.emit();
  }
}
